<template>
<div id="applogin" :style="styleappend + ''" v-cloak>

    <b-container>

        <div class="text-center">
            <h1 style="margin: 15px;" class="border-white">{{this.appname}}</h1>
        </div>

        <b-form @submit="onSubmit" class="form-signin" v-show="showdettaglio2">

            <b-card>

                <h5 class="form-signin-heading">{{'Effettua l\'accesso'}}</h5>

                <b-form-input id="account" type="text" v-model="form.account" required autofocus placeholder="N° Socio"></b-form-input>

                <b-form-input id="password" type="password" v-model="form.password" required placeholder="Password"></b-form-input>

<!--                 <b-form-checkbox id="savec" v-model="status" value="S" unchecked-value="N">
                    {{'Ricorda credenziali'}}
                </b-form-checkbox> -->
                <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                <b-button type="submit" :block="true" size="lg" variant="primary">{{'Accedi'}}</b-button>

                <b-button :block="true" size="lg" variant="warning" @click.stop="iscriviti()">{{'Iscriviti'}}</b-button>

                <div class="text-center">
                    <a style="color:black;" @click.stop="showPP()" href="#">Privacy Policy</a> - Questa pagina non utilizza Cookie
                </div>

            </b-card>

        </b-form>

        <b-alert :show="showerror2" variant="danger">{{ error2 }}</b-alert>

    </b-container>
</div>
</template>

<script>
 import {
     NAMESPACE
 } from '../config.js'

export default {
    name: 'applogin',
    data: function () {

        //var mem = localStorage.getItem('checkUte') || 'N'; //l'or fa la coalesce

        return {
            //ATTENZIONE: qui per future modifiche ci va a rifinire il nome del cral, serve per fare degli if per personalizzare il comportamento e visualizzazione delle pagine
            //Per il cral pignone il valore è: CRAL Nuovo Pignone che è salvato anche in tabella parametri
            appname: '',
            coloreutenti: '',
            styleappend: '',
            urlprivacypolicy: '',
            form: {
                //email: ((mem === 'S') ? localStorage.getItem('email') || '' : ''),
                //password: ((mem === 'S') ? localStorage.getItem('passwordUte') || '' : '')
                account: '',
                password: '',
            },
            //status: 'N', //mem,
            error: '',
            showerror: false,
            showdettaglio2: false,
            error2: '',
            showerror2: false,
        };
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();

            this.login(JSON.stringify(this.form));

        },
        showPP() {

            window.open(this.urlprivacypolicy, '_blank');

        },
        iscriviti() {
            this.$router.push('/autoiscrizione');
        },
        login(json) {

            let applogin = this;

            applogin.axios.post(NAMESPACE + 'rest/loginute', json, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            var res = response.data.message;

                            var token = res.token;

                            //console.log(res);

                            //return;

                            /*
                            localStorage.setItem('token', token);
                            localStorage.setItem('account', res.account);
                            localStorage.setItem('nome', res.nome);
                            localStorage.setItem('cognome', res.cognome);
                            localStorage.setItem('email', res.email);
                            localStorage.setItem('idsocio', res.id);
                            localStorage.setItem('vismenu', res.vismenu);
                            localStorage.setItem('viscategoria', res.viscategoria);
                            localStorage.setItem('appname', res.appname);
                            */

                            localStorage.setItem('token', token);
                            localStorage.setItem('account', res.account);
                            localStorage.setItem('nome', res.nome);
                            localStorage.setItem('cognome', res.cognome);
                            localStorage.setItem('email', res.email);
                            localStorage.setItem('idsocio', res.id);
                            localStorage.setItem('vismenu', res.vismenu);
                            localStorage.setItem('viscategoria', res.viscategoria);

                            //per distinguere quelli che aprono le pagine da app
                            localStorage.setItem('appname', res.appname);
                            localStorage.setItem('loginfromapp', "N");
                            localStorage.setItem('coloreutenticral', res.coloreutenticral);
                            localStorage.setItem('urlprivacypolicycral', res.urlprivacypolicycral);


                            // if (applogin.status == 'S') {
                            //     localStorage.setItem('checkUte', applogin.status);
                            //     localStorage.setItem('passwordUte', applogin.form.password);
                            // }
                            applogin.$router.push('/ute');

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        applogin.showerror = true;
                        applogin.error = 'Errore: ' + e.message;
                    }

                })
                .catch(e => {
                    //console.log (e);
                    applogin.showerror = true;
                    applogin.error = 'Errore: ' + (typeof e.response === 'undefined' ? 'Errore interno API' : (e.response.data.message instanceof Object ? 'Errore interno API' : e.response.data.message));
                });

            }

    },
    created: function () {

        //chiamo il servizio che mi restituisce i parametri per la grafica
        this.axios.get(NAMESPACE + 'rest/autoiscrizione/param', {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        var res = response.data.message;

                        this.appname = res.appname;

                        this.urlprivacypolicy = res.urlprivacypolicy;
                        this.coloreutenti = res.coloreutenti;
                        if((this.coloreutenti || "") != ""){
                            this.styleappend = "background: " + this.coloreutenti + ";";
                        }

                        this.showdettaglio2 = true;

                    }
                    else {
                        throw new Error(response.data.message);
                    }


                }
                catch (e) {
                    this.showerror2 = true;
                    this.error2 = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror2 = true;
                this.error2 = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });



    },
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#applogin {
    /*margin: -50px;*/
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #eee;
}

.form-signin {
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}

.form-signin .form-signin-heading,
.form-signin .checkbox {
    margin-bottom: 10px;
}

.form-signin .checkbox {
    font-weight: 400;
}

.form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
}

.form-signin .form-control:focus {
    z-index: 2;
}

.form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>
